import React from 'react';
import { ScreenProps } from '../../types/ptp';
import { SelectableChip } from '../ui/SelectableChip';
import { PrimaryButton } from '../ui/PrimaryButton';
const ENVIRONMENT_OPTIONS = ['Active construction site', 'Elevated structural work (>6 ft)', 'Work near crane operation', 'Work near moving equipment', 'Outdoor work environment', 'Wind exposure possible'];
export function WorkEnvironmentScreen({
  data,
  updateData,
  onNext
}: ScreenProps) {
  const handleToggle = (option: string) => {
    const current = data.environmentConditions;
    const updated = current.includes(option) ? current.filter(item => item !== option) : [...current, option];
    updateData({
      environmentConditions: updated
    });
  };
  return <div className="flex flex-col h-full" data-id="element-984">
      <div className="mb-6" data-id="element-985">
        <h2 className="text-2xl font-bold text-white mb-2" data-id="element-986">Work Environment</h2>
        <p className="text-slate-400" data-id="element-987">
          Select the primary conditions of the work area.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto pb-6 space-y-3 -mx-2 px-2" data-id="element-988">
        {ENVIRONMENT_OPTIONS.map(option => <SelectableChip key={option} label={option} selected={data.environmentConditions.includes(option)} onToggle={() => handleToggle(option)} data-id="element-989" />)}
      </div>

      <div className="pt-4" data-id="element-990">
        <PrimaryButton onClick={onNext} data-id="element-991">Continue</PrimaryButton>
      </div>
    </div>;
}